import React from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";

const AuthRoutes = (props) => {
  const { Auth, component: Component } = props;
  if (!Auth.isAuthenticated) {
    return <Component />;
  }
  return <Navigate to="/admin" replace />;
};
const mapStateToProps = (store) => ({
  Auth: store.Authentication,
});
export default connect(mapStateToProps)(AuthRoutes);

